import React from 'react';
import ReactDropzone from 'react-dropzone';
import {Avatar, Box, Link, Typography} from '@mui/material';
import {EXTENSIONS as SUPPORTED_EXTENSIONS} from '@apps-common/importer';
import {UploadFile as UploadFileIcon} from '@mui/icons-material';
import {array, func, node} from 'prop-types';
import {useTranslation} from 'react-i18next';

//ToDo: move to importer to centralize next to EXTENSIONS
// See https://react-dropzone.js.org/#section-accepting-specific-file-types
const SUPPORTED_FILE_TYPES = {
  'application/json': ['.geojson', '.json'],
  'application/octet-stream': ['.shp', '.shx', '.gpx'],
  'application/x-dbf': ['.dbf'],
  'apllication/text': ['.prj', '.wkt'],
  'application/vnd.google-earth.kml+xml': ['.kml'],
  'application/vnd.google-earth.kmz': ['.kmz'],
  'application/zip': ['.zip'],
};

export const DropZone = ({files = [], children, onDrop, ...props}) => {
  const {t} = useTranslation();

  return (
    <ReactDropzone
      noClick
      onDrop={onDrop}
      accept={SUPPORTED_FILE_TYPES}
      {...props}
    >
      {({getRootProps, getInputProps, isDragActive, open}) => (
        <>
          <Box
            {...getRootProps()}
            sx={{
              margin: 2,
              borderWidth: files.length > 0 ? 0 : 2,
              borderStyle: 'dashed',
              borderRadius: 1,
              borderColor: isDragActive ? 'primary.main' : 'divider',
              backgroundColor:
                files.length > 0 && !isDragActive
                  ? 'paper'
                  : isDragActive
                    ? 'primary.lighter'
                    : 'grey.100',
              outline: 'none',
              cursor: 'pointer',
              transition: 'color .24s ease-in-out, border .24s ease-in-out',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: files.length > 0 ? 'flex-start' : 'center',
              flex: '1 1 auto',
              position: 'relative',
            }}
            data-testid="dropzone"
          >
            <input {...getInputProps()} data-testid="drop-input" />
            {files.length === 0 && (
              <>
                <Avatar
                  sx={{
                    bgcolor: 'primary.lighter',
                    width: 56,
                    height: 56,
                    marginBottom: 2,
                  }}
                >
                  <UploadFileIcon fontSize="large" color="primary" />
                </Avatar>
                <Typography gutterBottom variant="h6" align="center" paragraph>
                  <Link
                    component="button"
                    variant="inherit"
                    color="primary"
                    onClick={open}
                  >
                    {t('uploadDialog.clickToUpload', 'Click to upload')}
                  </Link>{' '}
                  {t('uploadDialog.dragMessage', 'or drag and drop')}
                </Typography>
                <Typography align="center" color="textSecondary">
                  {t('uploadDialog.supportedFiles', {
                    extensions: SUPPORTED_EXTENSIONS.join(', '),
                  })}
                </Typography>
              </>
            )}
            {files.length > 0 && children}
          </Box>
        </>
      )}
    </ReactDropzone>
  );
};

DropZone.propTypes = {
  files: array,
  children: node,
  onDrop: func,
};

export default DropZone;
